<template>
  <div class="citydistict_container">
    <el-cascader :disabled="disabledStatus==='true'" style="width:200px;" v-model="operatingArea" :options="operatingAreaOptions" @change="handleItemChange"
      :props="{value:'areaId',label:'areaName',children:'child',emitPath:false}" clearable collapse-tags :placeholder="placeholderstr"></el-cascader>
  </div>
</template>

<script>
import citys_data from './citys.js'
import { Cascader } from 'element-ui';

export default {
    props: {
        defaultlevel1name: {
            type: String
        },
        defaultlevel2name: {
            type: String
        },
        placeholderstr: {
            type: String
        },
        disabledStatus:{
            type: String
        }
    },
    components: {
        [Cascader.name]: Cascader
    },
    data() {
        return {
            operatingArea: [], //选择的地区
            operatingAreaTrue: [], //根据选择的地区返回的你想要的数据列表
            operatingAreaOptions: citys_data,
        };
    },

    methods: {
        //根据获取地区的id获取区域名
        getCascaderObj(vals, opt) {
            let result = [];
            let _this = this;
            hasAera(opt, null);

            function hasAera(val, v) {
                for (let i of val) {
                    //根据选择的地区 areaId  ，判断是在地区列表的哪一块
                    if (vals.indexOf(i.areaId) != -1) {
                        result.push({
                            areaId: i.areaId,
                            areaName: i.areaName,
                            "provId": v.areaId,
                            "provName": v.areaName
                        });
                    } else if (i.child && i.child.length != 0) {
                        //如果第一层没有遍历到，第一层内有下一层
                        //那么继续调用方法，再次遍历子层数据
                        hasAera(i.child, i);
                    }
                }
            }
            return result;
        },
        //根据获取地区的id获取区域名
        handleItemChange(value) {

            for (let i of this.operatingAreaOptions) {
                i.disabled = false;
            }
            let arr = [];
            var provcity = {
                "areaId": "",
                "areaName": "",
                "provId": "",
                "provName": "",
            }
            try {
                let val = this.getCascaderObj(this.operatingArea, this.operatingAreaOptions);

                if (value) {
                    arr.push(...val);
                    this.operatingAreaTrue = arr;
                    provcity = {
                        "areaId": this.operatingAreaTrue[0]["areaId"],
                        "areaName": this.operatingAreaTrue[0]["areaName"],
                        "provId": this.operatingAreaTrue[0]["provId"],
                        "provName": this.operatingAreaTrue[0]["provName"],
                    };
                }

            } catch(error){

            }

            this.$emit('resetDefaultValue', provcity)
        },
        getIDs(provinceName, cityName) {
            let result = [];
            let _this = this;
            console.log(provinceName, cityName);
            let province_id = "";
            let area_id = "";

            for (let prov of this.operatingAreaOptions) {
                console.log();
                if (provinceName == prov.areaName && prov.child && prov.child.length != 0) {
                    for (let city of prov.child) {
                        if (cityName == city.areaName) {
                            area_id = city.areaId;
                            break;
                        }
                    }
                    province_id = prov.areaId;
                    break;
                }
            }
            return {
                "province_id": province_id,
                "area_id": area_id
            };
        },
    },
    mounted: function() {
        console.log(this.defaultlevel1name)
        console.log(this.defaultlevel2name)
        let pc = this.getIDs(this.defaultlevel1name, this.defaultlevel2name);
        console.log(pc);
        this.operatingArea = [pc["province_id"], pc["area_id"]];

    },
    watch: {
        defaultlevel1name(value) {

            this.defaultlevel1name = value;
        },
        defaultlevel2name(value) {

            this.defaultlevel2name = value;

            let pc = this.getIDs(this.defaultlevel1name, this.defaultlevel2name);
            console.log(pc);
            this.operatingArea = [pc["province_id"], pc["area_id"]];
        },
    }
}
</script>

<style scoped>
  .citydistict_container {
      display: inline-block;
  }
  .el-cascader-menu {
    height: 3rem;
  }

</style>
